import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from "react-router-dom";

function GroupCusAdd() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [groupName, setGroupName] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 30;

    const navigate = useNavigate();
    const { customer_group } = useParams();
    const user = getCookie('user');
    const initialFormData = { area_code: "", network: "", date: "", toDate: "" };
    const [formData, setFormData] = useState(initialFormData);

    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) return value;
        }
        return null;
    }

    if (!user) {
        navigate('/');
    }

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleClear = () => {
        setFormData(initialFormData);
    };

    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/groupGetInfo', { user });
            if (response.status === 200) {
                setGroupName(response.data.groupDetails);
                setAllCustomer(response.data.allCustomer);
            }
        } catch (err) {
            setError(err.response?.data?.message || "Error fetching data");
        } finally {
            setLoading(false);
        }
    };

    const stb = useMemo(() => allCustomer.map(row => parseInt(row.serial_num, 10)), [allCustomer]);

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(stb.join(", "))
            .then(() => toast.info(`${stb.length} STB numbers copied`))
            .catch((error) => toast.warning("Copy failed: " + error));
    };

    const downloadCSV = () => {
        const headers = [
            "Sno", "Customer__Name", "Acc_no", "Code", "STB_no", "D_no", "Flat_name", "Street__name",
            "Phone", "Pay Status", "Plan Amount", "Paid Amount", "Paid_Date", "Balance Amount",
            "Discount Amount", "Advance Amount", "Pending Amount", "Staff__Code", "Network",
            "Paid_time", "Package", "Added_date", "Collection Staff"
        ];
        const csvRows = [
            headers.join(","),
            ...allCustomer.map(row => [
                row.id, row.name, row.account_num, row.acc_num, row.serial_num, row.doorno,
                row.flat_name, row.street, row.mobile, row.status, row.pay_amt, row.paid_amt,
                row.paid_date, row.balance, row.discount, row.extra_balance_amt, row.pend_amt,
                row.area_code, row.net_name, row.paid_time, row.package, row.adate, row.col_boy
            ].join(","))
        ];
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "CableTvPay.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    if (loading) return (
        <div className="content-wrapper d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="loading-indicator" />
        </div>
    );

    if (error) return <div className="content-wrapper d-flex justify-content-center align-items-center min-vh-100">Error: {error}</div>;

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = groupName.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(groupName.length / rowsPerPage);

    const filteredRows = currentRows.filter(row =>
        Object.values(row).some(value =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <h4 className="mt-3">ADD {customer_group} GROUP CUSTOMER</h4>
                <ToastContainer theme="dark" />
                <hr />

                <div className="card elevation-5 mt-3" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    <span className="input-group-text">
                                        <i className="fas fa-search" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-body p-0">
                        <table className="table table-bordered table-responsive-lg">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Sl_No</th>
                                    <th>Customer Name</th>
                                    <th>Acc_no</th>
                                    <th>Code</th>
                                    <th>STB_no</th>
                                    <th>D_no</th>
                                    <th>Flat_name</th>
                                    <th>Street Name</th>
                                    <th>Phone</th>
                                    <th>Pay Status</th>
                                    <th>Plan Amount</th>
                                    <th>Paid Amount</th>
                                    <th>Paid Date</th>
                                    <th>Paid Time</th>
                                    <th>Balance Amount</th>
                                    <th>Discount Amount</th>
                                    <th>Advance Amount</th>
                                    <th>Pending Amount</th>
                                    <th>Staff Code</th>
                                    <th>Network</th>
                                    <th>Package</th>
                                    <th>Connection Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? filteredRows.map((row, index) => (
                                    <tr key={index} style={{ backgroundColor: row.status === "unpaid" ? "#ffffff" : "#fdfdfd" }}>
                                        <td>{row.id}</td>
                                        <td>{row.name}</td>
                                        <td>{row.account_num}</td>
                                        <td>{row.acc_num}</td>
                                        <td>{row.serial_num}</td>
                                        <td>{row.doorno}</td>
                                        <td>{row.flat_name}</td>
                                        <td>{row.street}</td>
                                        <td>{row.mobile}</td>
                                        <td>{row.status}</td>
                                        <td>{row.pay_amt}</td>
                                        <td>{row.paid_amt}</td>
                                        <td>{row.paid_date}</td>
                                        <td>{row.paid_time ? new Date(`1970-01-01T${row.paid_time}`).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true }) : ""}</td>
                                        <td>{row.balance_amt}</td>
                                        <td>{row.discount}</td>
                                        <td>{row.extra_balance_amt}</td>
                                        <td>{row.pend_amt}</td>
                                        <td>{row.area_code}</td>
                                        <td>{row.net_name}</td>
                                        <td>{row.package}</td>
                                        <td>
                                            <button className={`btn ${row.con_status?.toLowerCase() === "active" ? "btn-success" : "btn-secondary"}`}>
                                                {row.con_status}
                                            </button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="22">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <div className="pagination btn-group">
                            <button className="btn btn-secondary" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                                <i className="fas fa-backward"></i>
                            </button>

                            <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-navy" : "btn-secondary"}`}>1</button>

                            {currentPage > 3 && <span className="mx-1">...</span>}

                            {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                .filter(page => page > 1 && page < totalPages)
                                .map(page => (
                                    <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-navy" : "btn-outline-secondary"}`}>
                                        {page}
                                    </button>
                                ))}

                            {currentPage < totalPages - 2 && <span className="mx-1">...</span>}

                            {totalPages > 1 && (
                                <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-navy" : "btn-secondary"}`}>
                                    {totalPages}
                                </button>
                            )}

                            <button className="btn btn-secondary" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                                <i className="fas fa-forward"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GroupCusAdd;
